import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnTextEditorComponent } from './fn-text-editor.component';

export * from './fn-text-editor.component';
/**
 * Exports the required FnTextEditorComponent to create Tag Element
 * making them available for import by NgModules that import this module.
 */
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [FnTextEditorComponent],
    exports: [FnTextEditorComponent]
})
export class FnTextEditorModule {

}
